// import UnknownResult from './views/unknown'
// import SummaryResult from './views/summaryv2'
// import NextResult from './views/next'
// import TDNextResult from './views/tdnext'
import WiremapResult from "../views/wiremap";
// import FiberResult from './views/fiber'
import PingSubtest from "./views/pingtest";
import TracerouteSubtest from "./views/traceroutetest";
import ThreerowSubtest from "./views/threerowtest";
import WiremapSubtest from "./views/wiremaptest";
import QualificationSubtest from "./views/qualificationtest";
import MaxthroughputSubtest from "./views/maxthroughputtest";
import UptimeSubtest from "./views/uptimetest";
import StatsSubtest from "./views/statstest";
import QtRfTest from './views/qtrftest'

const ResultMap = {
  //Wiremap: WiremapResult,
  ping4: PingSubtest,
  ping6: PingSubtest,
  traceroute4: TracerouteSubtest,
  traceroute6: TracerouteSubtest,
  cabledata: TracerouteSubtest,
  poeload: ThreerowSubtest,
  webdata: ThreerowSubtest,
  voipdata: ThreerowSubtest,
  videodata: ThreerowSubtest,
  cctvdata: ThreerowSubtest,
  netscan: ThreerowSubtest,
  customdata: ThreerowSubtest,
  wiremap: WiremapSubtest,
  maxthroughput: MaxthroughputSubtest,
  uptime: UptimeSubtest,
  fiberlengthloss: ThreerowSubtest,
  qualification: QualificationSubtest,
  stats: StatsSubtest,
  qualification_il: QtRfTest,
  qualification_rl: QtRfTest,
  qualification_next: QtRfTest
};

const GetSignaltekThumbnailResultView = result => {
  return ResultMap.hasOwnProperty(result)
    ? ResultMap[result]
    : ResultMap["unknown"];
};

export default GetSignaltekThumbnailResultView;



// WEBPACK FOOTER //
// ./src/components/common/results/thumbnails/getSignaltekThumbnailResult.js